// blakfy-cookie/src/i18n/translations/hi.js — Hindi translations

export default {
  title: "कुकी प्राथमिकताएं",
  intro:
    "यह साइट आपके अनुभव को बेहतर बनाने के लिए कुकीज़ का उपयोग करती है। विवरण के लिए हमारी कुकी नीति देखें।",
  policyLink: "कुकी नीति",
  acceptAll: "सभी स्वीकार करें",
  rejectAll: "सभी अस्वीकार करें",
  preferences: "प्राथमिकताएं",
  save: "विकल्प सहेजें",
  close: "बंद करें",
  cat: {
    essential: {
      title: "आवश्यक कुकीज़",
      desc: "साइट के कार्य करने के लिए आवश्यक। अक्षम नहीं की जा सकतीं।",
      always: "हमेशा सक्रिय",
    },
    analytics: {
      title: "विश्लेषण कुकीज़",
      desc: "अज्ञात विज़िट आँकड़े एकत्र करने के लिए उपयोग की जाती हैं।",
    },
    marketing: {
      title: "मार्केटिंग कुकीज़",
      desc: "वैयक्तिकृत विज्ञापन और रिटार्गेटिंग के लिए उपयोग की जाती हैं।",
    },
    functional: {
      title: "कार्यात्मक कुकीज़",
      desc: "भाषा, थीम जैसी प्राथमिकताओं को याद रखने के लिए उपयोग की जाती हैं।",
    },
  },
  placeholder: {
    title: "सामग्री अवरुद्ध है",
    desc: "इस सामग्री को देखने के लिए आपको {category} कुकीज़ की अनुमति देनी होगी।",
    cta: "अनुमति दें",
  },
  tabs: {
    categories: "Categories",
    services: "Services",
    about: "About",
  },
  service: {
    description: "Description",
    processor: "Data Processor",
    address: "Address",
    dpo: "DPO Contact",
    purposes: "Purposes",
    technologies: "Technologies Used",
    dataCollected: "Data Collected",
    legalBasis: "Legal Basis",
    retention: "Retention Period",
    transferCountries: "Transfer Countries",
    privacyPolicy: "Privacy Policy",
    cookiePolicy: "Cookie Policy",
    legalBasisValues: {
      consent: "Consent (Art. 6 para. 1 s. 1 lit. a GDPR)",
      legitimate_interest: "Legitimate Interest (Art. 6 para. 1 s. 1 lit. f GDPR)",
    },
    noServices: "No services are configured for this site.",
  },
  svcAbout: {
    title: "About this CMP",
    description:
      "This website uses Blakfy Cookie Management Platform (CMP) to manage your consent preferences in compliance with GDPR, KVKK, CCPA and other applicable privacy regulations.",
    version: "Version",
    learnMore: "Learn more at blakfy.com",
  },
};
